// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-BadgeShell-badge-a4a7e867"};